import * as z from 'zod';
import { zParticipantInput } from '$lib/utils/participantUtils';

export type PublicMessage_UserOnline = {
    topic: `/public/user/${number}/online`;
    payload: {
        id: number;
        online: boolean;
        eventId: string;
    };
};

export type PublicMessage_CompanyOnline = {
    topic: `/public/company/${number}/online`;
    payload: {
        id: number;
        online: boolean;
        eventId: string;
    };
};

export type PublicMessage = PublicMessage_UserOnline | PublicMessage_CompanyOnline;

const zUserEventDataMapByEventName = {
    'notification/new-notification': z.object({
        event: z.literal('notification/new-notification'),
        payload: z.object({
            id: z.number(),
        }),
    }),
    'inbox/new-message': z.object({
        event: z.literal('inbox/new-message'),
        payload: z.object({
            message: z.number(),
            thread: z.number(),
        }),
    }),
    'inbox/message-mark-read': z.object({
        event: z.literal('inbox/message-mark-read'),
        payload: z.object({
            message: z.number(),
            thread: z.number(),
            participant: zParticipantInput,
        }),
    }),
    'inbox/message-deleted': z.object({
        event: z.literal('inbox/message-deleted'),
        payload: z.object({
            message: z.number(),
            thread: z.number(),
            participant: zParticipantInput,
        }),
    }),
    'inbox/thread-mark-read': z.object({
        event: z.literal('inbox/thread-mark-read'),
        payload: z.object({
            thread: z.number(),
            participant: zParticipantInput,
        }),
    }),
    'inbox/thread-deleted': z.object({
        event: z.literal('inbox/thread-deleted'),
        payload: z.object({
            thread: z.number(),
            participant: zParticipantInput,
        }),
    }),
    'inbox/participant-writing-on-thread': z.object({
        event: z.literal('inbox/participant-writing-on-thread'),
        payload: z.object({
            thread: z.number(),
            participant: zParticipantInput,
            participantName: z.string(),
        }),
    }),
} as const;

export const zUserEventData = z.discriminatedUnion('event', [
    zUserEventDataMapByEventName['notification/new-notification'],
    zUserEventDataMapByEventName['inbox/new-message'],
    zUserEventDataMapByEventName['inbox/message-mark-read'],
    zUserEventDataMapByEventName['inbox/message-deleted'],
    zUserEventDataMapByEventName['inbox/thread-mark-read'],
    zUserEventDataMapByEventName['inbox/thread-deleted'],
    zUserEventDataMapByEventName['inbox/participant-writing-on-thread'],
]);

export type UserEventData = z.infer<typeof zUserEventData>;

export type UserEventDataByEventName = {
    [EventName in keyof typeof zUserEventDataMapByEventName]: z.infer<
        (typeof zUserEventDataMapByEventName)[EventName]
    >;
};
